import React from 'react';

import {connect} from 'react-redux';

import CheckBox from 'components/CheckBox';
import {RoomCheckDescription} from 'containers/BookingSetDetail/components';

import {
  editArrivalRoomCheckDescription,
  fetchArrivalRoomChecks,
  fetchBookingSet,
  fetchRoomChecksTimeline,
  editArrivalRoomCheckExistingDamages,
  MODALS,
  fetchArrivalRoomCheck,
  editArrivalRoomCheckStatus,
  ROOM_CHECK_STATUSES
} from 'ducks/bookingSets';
import {composeActions} from 'ducks/common';
import {storeDataInModal} from 'ducks/modals';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import './styles.css';

interface ArrivalRoomCheckProps {
  id: number;
  roomNumber: string;
  roomType: string;
  existingDamages: boolean;
  description: string;
  status: string;
}

interface ArrivalRoomCheckBasicInformationProps {
  arrivalRoomCheck: ArrivalRoomCheckProps;
  bookingSetId: number;
  edittingDescription: boolean;
  fetchArrivalRoomCheckExtraActions: any;
  editArrivalRoomCheckDescription: any;
  editArrivalRoomCheckExistingDamages: any;
  storeDataInModal: any;
  composeActions: any;
  requiresPermission: any;
  editArrivalRoomCheckStatus: any;
  locationRef: string;
}

class ArrivalRoomCheckDetails extends React.Component<
  ArrivalRoomCheckBasicInformationProps
> {
  state = {
    editDescription: false
  };

  onExistingDamagesChange = event => {
    const newExistingDamagesValue = event.target.checked;

    const {bookingSetId, arrivalRoomCheck} = this.props;
    const arrivalRoomCheckId = arrivalRoomCheck.id;

    const extraActions = [
      () =>
        fetchArrivalRoomCheck(
          {roomCheckId: arrivalRoomCheckId, bookingSetId},
          this.props.fetchArrivalRoomCheckExtraActions()
        ),
      () => fetchArrivalRoomChecks({bookingSetId}),
      () => fetchBookingSet({bookingSetId})
    ];

    this.props.editArrivalRoomCheckExistingDamages(
      {
        bookingSetId,
        arrivalRoomCheckId,
        newExistingDamages: newExistingDamagesValue
      },
      extraActions
    );
  };

  submitEditDescriptionForm = ({newDescription}) => {
    const {bookingSetId, arrivalRoomCheck} = this.props;
    const arrivalRoomCheckId = arrivalRoomCheck.id;

    const extraActions = [
      () =>
        fetchArrivalRoomCheck({roomCheckId: arrivalRoomCheckId, bookingSetId}, [
          data =>
            this.props.storeDataInModal({
              modalName: MODALS.ARRIVAL_ROOM_CHECK_DETAIL_MODAL,
              data: {arrivalRoomCheck: data, edittingDescription: false}
            })
        ]),
      () => fetchArrivalRoomChecks({bookingSetId}),
      () => fetchBookingSet({bookingSetId})
    ];

    this.props.composeActions([
      () =>
        this.props.storeDataInModal({
          modalName: MODALS.ARRIVAL_ROOM_CHECK_DETAIL_MODAL,
          data: {edittingDescription: true}
        }),
      () =>
        this.props.editArrivalRoomCheckDescription(
          {
            bookingSetId,
            arrivalRoomCheckId,
            newDescription
          },
          extraActions
        )
    ]);
  };

  onStatusChange = () => {
    const {bookingSetId, arrivalRoomCheck, locationRef} = this.props;
    const arrivalRoomCheckId = arrivalRoomCheck.id;

    this.props.requiresPermission(
      {permission: PERMISSIONS.COMPLETE_ROOM_CHECK, locationRef},

      () => {
        const extraActions = [
          () =>
            fetchArrivalRoomCheck(
              {roomCheckId: arrivalRoomCheckId, bookingSetId},
              this.props.fetchArrivalRoomCheckExtraActions()
            ),
          () => fetchArrivalRoomChecks({bookingSetId}),
          () => fetchBookingSet({bookingSetId}),
          () => fetchRoomChecksTimeline({bookingSetId})
        ];

        this.props.editArrivalRoomCheckStatus(
          {
            bookingSetId,
            arrivalRoomCheckId
          },
          extraActions
        );
      }
    );
  };

  render() {
    const {
      arrivalRoomCheck: {existingDamages, description, status},
      edittingDescription
    } = this.props;

    const isCompleted = status == ROOM_CHECK_STATUSES.COMPLETED;

    return (
      <div className="ArrivalRoomCheckDetails">
        <div className="ArrivalRoomCheckDetails__section">
          <CheckBox
            name="existingDamages"
            label="Existing damages"
            defaultChecked={existingDamages}
            onChange={this.onExistingDamagesChange}
          />
        </div>

        <div className="ArrivalRoomCheckDetails__section">
          <CheckBox
            name="completeRoomCheck"
            label="Complete room check?"
            value={isCompleted}
            onChange={this.onStatusChange}
            disabled={isCompleted}
          />
        </div>
        <RoomCheckDescription
          description={description}
          editFormName="editArrivalRoomCheckDescriptionForm"
          submitEditDescriptionForm={this.submitEditDescriptionForm}
          edittingDescription={edittingDescription}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  editArrivalRoomCheckDescription,
  editArrivalRoomCheckExistingDamages,
  storeDataInModal,
  composeActions,
  requiresPermission,
  editArrivalRoomCheckStatus
};

export default connect(null, mapDispatchToProps)(ArrivalRoomCheckDetails);
